export const SloppingLines = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M0 18.4574L6.07614 0L10.9264 1.48936L5.06345 20L0 18.4574ZM10.0736 18.4574L16.1497 0L21 1.48936L15.1371 20L10.0736 18.4574Z"
        fill="#0F3B40"
      />
    </svg>
  );
};
